import styled from 'styled-components';
import { primitives } from '@veneer/primitives';
const { color, typography } = primitives;

export const Container = styled.div`
  padding: 40px;
`;

export const StyledMainTitle = styled.h2`
  font-family: ${typography.family0};
  color: ${color.black};
  font-size: ${typography.size7};
  line-height: ${typography.lineHeight5};
  font-weight: ${typography.weight4};
  margin-bottom: 50px;
  span {
    color: ${color.powerStorm6};
  }
`;

export const StyledBreadcrumbs = styled.p`
  font-family: ${typography.family0};
  color: ${color.gray12};
  margin-bottom: 10px;
`;

export const PrinterSectionContainer = styled.div`
  display: flex;
  gap: ${typography.size2};
  width: 100%;

  @media (max-width: 750px) {
    flex-direction: column;
    gap: ${typography.size0};
  }
  margin-bottom: ${typography.size10};
`;

export const PrinterDetailsContainer = styled.div`
  flex: 1;
  min-width: 0;
`;
export const ImageContainer = styled.div`
  flex: 1;
  min-width: 0;
`;
export const PrinterModelsContainer = styled.div``;
export const FAQContainer = styled.div`
  flex: 1;
  min-width: 0;
`;
